import * as StoreUtil from '../util/InClientStoreUtil';
import UninstallAppRequest from 'owa-service/lib/contract/UninstallAppRequest';
import UninstallExtensionJsonRequest from 'owa-service/lib/contract/UninstallExtensionJsonRequest';
import UninstallExtensionJsonRequestFactory from 'owa-service/lib/factory/uninstallExtensionJsonRequest';
import UninstallExtensionJsonResponse from 'owa-service/lib/contract/UninstallExtensionJsonResponse';
import UninstallExtensionOperation from 'owa-service/lib/operation/uninstallExtensionOperation';
import { createOverrideOptions } from '../util/InClientStoreHelper';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import ServiceEndpoint = OSF.ServiceEndpoint;

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'UninstallOutlookWebExt',
        (data: any, responseMethod: Function) => {
            UninstallOutlookWebExt(data).then(response => {
                if (response.Body.ResponseClass.toString() == 'Error') {
                    responseMethod(
                        [
                            response.Body.MessageText.toString(),
                            response.Body.ResponseCode.toString(),
                        ],
                        -1
                    );
                } else {
                    responseMethod([data.toString()], 0);
                    StoreUtil.updateAddinSurface();
                }
            });
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}

function UninstallOutlookWebExt(data: any): Promise<UninstallExtensionJsonResponse> {
    const Body: UninstallAppRequest = {
        __type: 'UninstallAppRequest:#Exchange',
        ID: data.toString(),
    };
    const UninstallRequest: UninstallExtensionJsonRequest = {
        Header: getJsonRequestHeader(StoreUtil.getUserTimeZone()),
        Body: Body,
    };

    const params: UninstallExtensionJsonRequest = UninstallExtensionJsonRequestFactory(
        UninstallRequest
    );
    const fetchOptions = createOverrideOptions();

    return UninstallExtensionOperation(params, fetchOptions);
}
